(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sh-pdp-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGallery(g) {
      if (g.dataset.shReady) return;
      g.dataset.shReady = '1';
      var thumbs = g.querySelectorAll('[data-sh-thumb]');
      var mains = g.querySelectorAll('[data-sh-main]');

      // COMPARTIR: share sheet nativo (móvil) o copiar enlace con aviso.
      // Se vincula ANTES del corte de placeholders: funciona también sin fotos.
      var shareBtn = g.querySelector('[data-sh-share]');
      if (shareBtn && !shareBtn.dataset.shBound) {
        shareBtn.dataset.shBound = '1';
        var tip = shareBtn.querySelector('[data-sh-share-tip]');
        var tipTimer;
        var showTip = function (msg) {
          if (!tip) return;
          tip.textContent = msg;
          tip.hidden = false;
          clearTimeout(tipTimer);
          tipTimer = setTimeout(function () { tip.hidden = true; }, 1800);
        };
        shareBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var data = { title: shareBtn.dataset.title || document.title, url: shareBtn.dataset.url || location.href };
          if (navigator.share) {
            navigator.share(data).catch(function () {});
          } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(data.url).then(function () {
              showTip(shareBtn.dataset.copied || 'Link copied');
            }).catch(function () {});
          }
        });
        shareBtn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
        });
      }

      if (!mains.length) return; // placeholders: nada que cambiar

      function activateIndex(idx) {
        idx = String(idx);
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-sh-thumb') === idx); });
        mains.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-sh-main') === idx); });
      }
      function indexForMediaId(mediaId) {
        for (var i = 0; i < mains.length; i++) {
          if (mains[i].getAttribute('data-media-id') === String(mediaId)) return mains[i].getAttribute('data-sh-main');
        }
        return null;
      }

      // 1) Clic en miniatura → cambia la imagen grande (y detiene el autoplay:
      //    el cliente tomó el control)
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          activateIndex(t.getAttribute('data-sh-thumb'));
        });
      });

      // 1b) La galería NO rota sola (decisión del dueño, 12-ago). Antes la imagen
      //     principal cambiaba cada 5 s con 2+ fotos, y como la columna es sticky
      //     lo hacía en el campo visual del cliente durante todo el scroll,
      //     mientras leía las notas y el precio. Le Labo, Aesop y Frédéric Malle
      //     no rotan nunca la foto de producto: la quietud es el mensaje.
      //     (También evita el incumplimiento de WCAG 2.2.2 — movimiento
      //     automático de más de 5 s sin mecanismo de pausa.)
      //     La foto avanza solo por gesto: miniatura, lightbox o teclado.

      // 2) Cambio por VARIANTE: cuando Dawn actualiza [name="id"], si la variante
      //    tiene foto propia, saltamos a esa imagen. (No-op si comparten media.)
      var mapEl = g.querySelector('[data-sh-variant-media]');
      if (mapEl) {
        var vmap = {};
        try { vmap = JSON.parse(mapEl.textContent || '{}'); } catch (e) {}
        var host = g.closest('product-info') || document.querySelector('product-info') || g.closest('.product') || document;
        function idInput() { return host.querySelector && host.querySelector('[name="id"]'); }
        var lastId = null;
        function syncVariant() {
          var input = idInput();
          if (!input) return;
          var vid = input.value;
          if (vid === lastId) return;
          lastId = vid;
          var mid = vmap[vid];
          if (mid == null) return;
          var idx = indexForMediaId(mid);
          if (idx != null) activateIndex(idx);
        }
        if ('MutationObserver' in window) {
          new MutationObserver(syncVariant).observe(host === document ? document.body : host, { childList: true, subtree: true });
        }
        // También en cambios directos del selector de variante (respaldo inmediato)
        document.addEventListener('change', function (e) {
          if (e.target && e.target.closest && e.target.closest('product-info, .product')) syncVariant();
        });
        syncVariant();
      }

      // 3) ZOOM (lightbox)
      var opener = g.querySelector('[data-sh-zoom-open]');
      var box = g.parentElement && g.parentElement.querySelector('[data-sh-lightbox]');
      if (!box) box = document.querySelector('[data-sh-lightbox]');
      // Reubicar al <body> para que position:fixed sea siempre relativo al viewport
      // (blindaje ante ancestros con transform/filter/sticky).
      if (box && box.parentElement !== document.body) document.body.appendChild(box);
      if (opener && box) {
        var lbImg = box.querySelector('[data-sh-lightbox-img]');
        var veil = box.querySelector('[data-sh-lightbox-veil]');
        var btnClose = box.querySelector('[data-sh-lightbox-close]');
        var btnPrev = box.querySelector('[data-sh-lightbox-prev]');
        var btnNext = box.querySelector('[data-sh-lightbox-next]');
        var lastFocus = null;

        function currentIndex() {
          var active = g.querySelector('[data-sh-main].is-active') || mains[0];
          return parseInt(active.getAttribute('data-sh-main'), 10) || 0;
        }
        function showInBox(i) {
          i = (i + mains.length) % mains.length;
          var m = mains[i];
          activateIndex(m.getAttribute('data-sh-main')); // mantiene sincronía con la galería
          lbImg.src = m.getAttribute('data-zoom-src') || m.getAttribute('src');
          lbImg.alt = m.getAttribute('alt') || '';
        }
        function open() {
          lastFocus = document.activeElement;
          showInBox(currentIndex());
          box.hidden = false;
          box.setAttribute('aria-hidden', 'false');
          void box.offsetWidth; // fuerza reflow → la transición corre sin depender de rAF (robusto en tabs ocultas)
          box.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          (btnClose || box).focus();
          document.addEventListener('keydown', onKey);
        }
        function close() {
          box.classList.remove('is-open');
          box.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          document.removeEventListener('keydown', onKey);
          var done = function () { box.hidden = true; box.removeEventListener('transitionend', done); };
          box.addEventListener('transitionend', done);
          setTimeout(done, 360); // respaldo si no dispara transitionend
          if (lastFocus && lastFocus.focus) lastFocus.focus();
        }
        function onKey(e) {
          if (e.key === 'Escape') { close(); }
          else if (e.key === 'ArrowRight' && btnNext) { showInBox(currentIndex() + 1); }
          else if (e.key === 'ArrowLeft' && btnPrev) { showInBox(currentIndex() - 1); }
          else if (e.key === 'Tab') {
            // Focus trap: Tab circula dentro del lightbox, no escapa al fondo
            var els = box.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');
            var vis = Array.prototype.filter.call(els, function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
            if (!vis.length) return;
            var first = vis[0], last = vis[vis.length - 1];
            if (e.shiftKey && (document.activeElement === first || !box.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && (document.activeElement === last || !box.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
          }
        }
        // Los chips (compartir/wishlist) viven dentro del opener: sus clics no abren el zoom
        opener.addEventListener('click', function (e) {
          if (e.target.closest('[data-sh-share], [data-sh-wish]')) return;
          open();
        });
        // El div ya no es focusable, así que su keydown no lo dispara nadie:
        // el teclado entra por el botón de la lupa.
        var zoomBtn = g.querySelector('[data-sh-zoom-btn]');
        if (zoomBtn) zoomBtn.addEventListener('click', function (e) { e.stopPropagation(); open(); });
        if (veil) veil.addEventListener('click', close);
        if (btnClose) btnClose.addEventListener('click', close);
        if (btnPrev) btnPrev.addEventListener('click', function () { showInBox(currentIndex() - 1); });
        if (btnNext) btnNext.addEventListener('click', function () { showInBox(currentIndex() + 1); });
      }
    }
    function boot() { document.querySelectorAll('[data-sh-gallery]').forEach(initGallery); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
